class Anchouter {
    constructor(data) {
        this.initialAnchor = data.initial;
        this.endPointAnchor = data.endpoint;
        this.target = document.querySelector(`.${data.target}`);

        this._init();
    }

    _init() {
        if (window.mobileMedia) {
            this._moveBetweenAnchors();
        }

        window.addEventListener("resize", () => {
            this._moveBetweenAnchors();
        });
    }

    _moveBetweenAnchors() {
        if (!this.target) return;

        if (window.mobileMedia) {
            if (this.target.previousSibling !== this.endPointAnchor) {
                this.endPointAnchor.after(this.target);
                this.target.classList.add("moved-by-anchouter");
            }
        } else if (this.target.previousSibling !== this.initialAnchor) {
            this.initialAnchor.after(this.target);
            this.target.classList.remove("moved-by-anchouter");
        }
    }
}

let nodeIterator = document.createNodeIterator(document.body, NodeFilter.SHOW_COMMENT);
const moverData = [];

while (nodeIterator.nextNode()) {
    const commentNode = nodeIterator.referenceNode;
    let commentValue = commentNode.nodeValue;
    const targetClass = commentValue.split('"')[1];

    if (commentValue.includes("anchouter-initial") && !commentValue.includes("anchouter-target")) {
        console.log("Для инициализатора перемещения не задан параметр anchouter-target", commentNode);
        continue;
    }

    if (commentValue.includes("anchouter-initial") && commentValue.includes("anchouter-target") && !targetClass) {
        console.log("Для инициализатора перемещения не задан класс цели", commentNode);
        continue;
    }

    if (commentValue.includes("anchouter-endpoint") && !commentValue.includes("anchouter-target")) {
        console.log("Для перемещения не задан параметр anchouter-target", commentNode);
        continue;
    }

    if (commentValue.includes("anchouter-endpoint") && commentValue.includes("anchouter-target") && !targetClass) {
        console.log("Для перемещения не задан класс цели", commentNode);
        continue;
    }

    if (commentValue.includes("anchouter-target") && targetClass) {
        const data = {
            target: targetClass,
            initialAnchor: null,
            endPointAnchor: null,
        };

        if (commentValue.includes("anchouter-initial")) {
            data.initialAnchor = commentNode;
        } else if (commentValue.includes("anchouter-endpoint")) {
            data.endPointAnchor = commentNode;
        }

        moverData.push(data);
    }
}

for (let i = 0; i < moverData.length; i++) {
    const data = moverData[i];

    if (data.initialAnchor && !data.used) {
        for (let j = 0; j < moverData.length; j++) {
            const moverDataJ = moverData[j];

            if (moverDataJ.endPointAnchor && !moverDataJ.used) {
                if (data.target === moverDataJ.target) {
                    new Anchouter({
                        target: data.target,
                        initial: data.initialAnchor,
                        endpoint: moverDataJ.endPointAnchor,
                    });

                    data.used = true;
                    moverDataJ.used = true;

                    break;
                }
            }
        }
    }

    if (data.endPointAnchor && !data.used) {
        for (let j = 0; j < moverData.length; j++) {
            const moverDataJ = moverData[j];

            if (moverDataJ.initialAnchor && !moverDataJ.used) {
                if (data.target === moverDataJ.target) {
                    new Anchouter({
                        target: data.target,
                        initial: moverDataJ.initialAnchor,
                        endpoint: data.endPointAnchor
                    });

                    data.used = true;
                    moverDataJ.used = true;

                    break;
                }
            }
        }
    }
}

for (let i = 0; i < moverData.length; i++) {
    const data = moverData[i];

    if (data.initialAnchor && !data.used) {
        console.log(`Не задан пункт назначения для перемещения ${data.target}`, data.initialAnchor, "Не найдена пара");
    }

    if (data.endPointAnchor && !data.used) {
        console.log(`Не задан инициализатор для перемещения ${data.target}`, data.endPointAnchor, "Не найдена пара");
    }
}
